import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PaymentStateService } from '../../modules/payment/services/payment-state.service';
import { environment } from '../../../environments/environment';
import { PaymentProvider } from '../../modules/payment/models/payment-provider';
import { ShopSettingsService } from '../../modules/general/services/shop-settings.service';
import { Subscription } from 'rxjs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-page-footer',
  templateUrl: 'page-footer.component.html',
  styleUrls: ['page-footer.component.css']
})
export class PageFooterComponent implements OnInit, OnDestroy {

  paymentProviders: PaymentProvider[];
  private _paymentProvidersSubscription: Subscription;
  private _customFooterSafe: SafeHtml;

  constructor(
    private router: Router,
    private paymentStateService: PaymentStateService,
    private shopSettingsService: ShopSettingsService,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
    if (this.shopSettingsService.isWebshopMode) {
      this._paymentProvidersSubscription = this.paymentStateService.paymentProviders.subscribe(
        paymentProviders => {
          this.paymentProviders = paymentProviders;
        });
    }
  }

  ngOnDestroy(): void {
    if (this._paymentProvidersSubscription) {
      this._paymentProvidersSubscription.unsubscribe();
      this._paymentProvidersSubscription = null;
    }
  }

  contact(): void {
    if (this.contactLink) {
      return;
    }
    this.router.navigateByUrl('contact');
  }

  faq(): void {
    this.router.navigateByUrl('faq');
  }

  privacy(): void {
    if (this.privacyLink) {
      return;
    }
    this.router.navigateByUrl('privacy');
  }

  agb(): void {
    if (this.termsConditionsLink) {
      return;
    }
    if (environment.globalSettings.shopCountry === 'HU') {
      this.router.navigateByUrl('aszf');
      return;
    }
    this.router.navigateByUrl('agb');
  }

  impressum(): void {
    if (this.imprintLink) {
      return;
    }
    this.router.navigateByUrl('impressum');
  }

  get isOgonePayment(): boolean {
    return this.paymentProviders && this.paymentProviders.some(x => x.name.toLowerCase() === 'ogone');
  }

  get isPayonePayment(): boolean {
    return this.paymentProviders && this.paymentProviders.some(x => x.name.toLowerCase() === 'payone');
  }

  get isStripePayment(): boolean {
    return this.paymentProviders && this.paymentProviders.some(x => x.name.toLowerCase() === 'stripe');
  }

  get isPaypalPayment(): boolean {
    return this.paymentProviders && this.paymentProviders.some(x => x.name.toLowerCase() === 'paypal');
  }

  get isSofortPayment(): boolean {
    return this.paymentProviders && this.paymentProviders.some(x => x.name.toLowerCase() === 'sofort');
  }

  get isGPWebpayPayment(): boolean {
    return this.paymentProviders && this.paymentProviders.some(x => x.name.toLowerCase() === 'gpwebpay');
  }

  get showContact(): boolean {
    return this.shopSettingsService.shopSettings.showContactMenu;
  }

  get isPaymentProviderExist(): boolean {
    return this.isOgonePayment || this.isOgonePayment || this.isSofortPayment || this.isPaypalPayment || this.isPayonePayment;
  }

  get isCustomFooter(): boolean {
    return this.shopSettingsService?.shopSettings?.isCustomFooter || null;
  }

  get customFooter(): string {
    return this.shopSettingsService?.shopSettings?.customFooter || null;
  }

  get customFooterSafe(): SafeHtml {
    if (!this._customFooterSafe && this.customFooter && this.customFooter.length) {
        this._customFooterSafe = this.sanitizer.bypassSecurityTrustHtml(this.customFooter);
    }
    return this._customFooterSafe;
  }

  get contactLink(): string {
    return this.shopSettingsService?.shopSettings?.contactLink || null;
  }

  get privacyLink(): string {
    return this.shopSettingsService?.shopSettings?.privacyLink || null;
  }

  get imprintLink(): string {
    return this.shopSettingsService?.shopSettings?.imprintLink || null;
  }

  get termsConditionsLink(): string {
    return this.shopSettingsService?.shopSettings?.termsConditionsLink || null;
  }

  get showTermsConditionsLink(): boolean {
    return this.shopSettingsService?.shopSettings?.showTermsConditionsLink;
  }

  get showPrivacyLink(): boolean {
    return this.shopSettingsService?.shopSettings?.showPrivacyLink;
  }

  get showImprintLink(): boolean {
    return this.shopSettingsService?.shopSettings?.showImprintLink;
  }
}
